var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables36 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "641.821px",
    height: "880.824px",
    viewBox: "0 0 641.821 880.824",
    enableBackground: "new 0 0 641.821 880.824",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.697,829.845l-28.707,50.979L47.37,776.817l24.974-44.379 C-3.038,649.091-23.582,530.49,30.128,435.175c117.168-207.975,260.411-102.021,332.929-213.211l12.215,6.896 c42.283-272.086,102.137-299.792,100.022-92.588C577.521-0.435,613.258,23.902,540.669,184.722 c136.186-82.52,140.67-26.472-22.133,124.866l9.66,5.432c-47.97,129.027,103.304,187.902-12.594,393.649 C465.326,797.875,363.966,842.032,260.697,829.845L260.697,829.845z M98.784,485.493l102.445,61.916 c18.153-35.011,42.766-84.573,74.821-122.944l-48.158-56.647C176.187,389.795,129.076,436.338,98.784,485.493L98.784,485.493z  M297.563,401.689c15.793-14.484,33.081-25.634,52.028-31.215c-29.076-16.12-59.62-19.106-89.533-12.896L297.563,401.689z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables36, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-36.b13d4e81.svg";
export { ForwardRef as ReactComponent };